import { Box, Button, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { useTranslation } from 'react-i18next';

const ErrorFallback = ({ message = null, onRetry, ...props }) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={2}
      padding="2rem"
      {...props}
    >
      <WarningIcon sx={{ fontSize: 64 }} color="warning" />
      <Typography variant="h3">{t('GENERAL_ERROR')}</Typography>
      <Typography variant="body1">{message}</Typography>
      {typeof onRetry === 'function' && (
        <Button variant="contained" onClick={onRetry} color="primary">
          {t('error.retry_button_text')}
        </Button>
      )}
    </Box>
  );
};

export default ErrorFallback;
